import styled, { css } from 'styled-components';

const headerHeight = 78;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 40px 40px;
    height: calc(100vh - ${headerHeight}px);

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 0;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 0 0 120px 0;
    }
  `}
`;

export const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      padding: 0px;
      border: 0px;
      & > div {
        padding: 0px;
      }
    }
`;

export const AccountName = styled.span`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      line-height: ${theme.v2.font.lineHeight.text};
    `};
`;

export const SelectedAccountRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: center;
`;

const getBgColor = (platform) => {
  if (platform === 'instagram') {
    return css`
      background: linear-gradient(
        45deg,
        #FFD521 0%,
        #FFD521 5%,
        #F50000 50.11%,
        #B900B4 95%,
        #B900B4 95.01%,
        #B900B4 100%
      );
    `;
  }
  if (platform === 'facebook') {
    return css`
      background: #1877F2;
    `;
  }
  return css``;
};

export const SocialMediaWrapper = styled.div`
    ${({ $platform }) => css`
      ${getBgColor($platform)}
      align-items: center;
      border-radius: 1000px;
      display: flex;
      justify-content: center;
      height: 28px;
      width: 28px;
      flex-shrink: 0;
      overflow: visible;
    `}
`;
